import React from "react";
import { Profile } from "./Profile";
import Widgets from "./Widgets";
import { useSelector } from "react-redux";
import { getThemeColor } from "Store/reducers/Auth/AuthSlice";

const Dashboard = () => {
  const themeColor = JSON.parse(useSelector(getThemeColor));
  return (
    <div
      className="flex md:flex-row flex-col min-h-screen"
      style={{ backgroundColor: themeColor?.background }}
    >
      {/* Profile Section */}
      <Profile />

      {/* Widgets Section */}
      <div className="flex flex-col items-start md:w-4/6 w-full md:pe-8 md:py-8 sm:p-8 sm:pe-12 sm:py-10 p-5 pt-0">
        <Widgets />
      </div>
    </div>
  );
};

export default Dashboard;
